"use client";

import { Toast, type FeedbackTone } from "./feedback";

export function FlashToast({ message, onDone, duration = 4400, tone = "primary" }: { message: string; onDone: () => void; duration?: number; tone?: FeedbackTone }) {
  return <Toast open message={message} onClose={onDone} duration={duration} tone={tone} />;
}
